export enum FlatBuffersVersionDTO {
  BETA_FIVE = 'BETA_FIVE',
  BETA_SIX = 'BETA_SIX',
  BETA_SEVEN = 'BETA_SEVEN',
  VERSION_EIGHT = 'VERSION_EIGHT',
  VERSION_NINE = 'VERSION_NINE',
  VERSION_TEN = 'VERSION_TEN',
  VERSION_ELEVEN = 'VERSION_ELEVEN',
}
